import * as React from "react";
import { Button } from "antd";
import { DialogMessageType } from "@/types/commands";

export default function ConfirmPlaceholder() {
  const onOk = () => {
    try {
      Office.context.ui.messageParent(DialogMessageType.CLOSE_CONFIRM_PLACEHOLDER);
    } catch {}
  };

  return (
    <div className="py-2 px-6 flex flex-col items-center justify-center text-center">
        <div className="text-sm text-gray-800">
          Confirm when new placeholder created with the <b>size and positioning</b> finalized:
        </div>
        <div className="mt-4 flex justify-center w-full">
          <Button type="primary" onClick={onOk}>Okay</Button>
        </div>
    </div>
  );
}

